import React, { useEffect, useState } from "react"
import { Link, useHistory } from "react-router-dom"
import DeleteModal from "../../../../components/Common/DeleteModal"
import { usePagination } from "../../../../hooks/usePagination"
import ResultHandler from "../../../../components/ResultHandler"
import PaginationHandler from "../../../../components/PaginationHandler"
import { deleteInvoice, getContractInvoices, getInvoices } from "../../../../api/invoices"
import TableHeaderHandler from "../../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../../hooks/useResponse"
import TableAction from "../../../../components/TableAction"
import EmptyData from "../../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../../api/permissions";
import { Badge, Button, Col, Label, Row } from "reactstrap"
import ImportCard from "../../../../components/ImportModal"
import { useParams } from "react-router-dom"
import moment from "moment"
import InvoicePayModal from "./InvoicePayModal"
import { formatCurrency } from "../../../../utils/formatCurrency"
import SendInvoicesMailModal from "./SendInvoicesMailModal"
import TableFilter from "../../../../components/TableFilter"

const STATUSE = {
  pending: {color: "warning", text: "Pending"},
  paid: {color: "success", text: "Paid"},
  rejected: {color: "danger", text: "Rejected"},

}

export default function InvoicesTable() {

  const { t } = useTranslation()
  let navigate = useHistory()
  const {contractId} = useParams()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta,
  } = usePagination(contractId ? getContractInvoices : getInvoices, {contractId})

  function handleRefresh(){
    setPayload({contractId, refetch: true})
  }

  // Filter
  const filterTypes = [
    {key: "date", type: "date"},
    {key: "status", type: "select", options: [
      {label: "All", value: "all"},
      {label: "Paid", value: "paid"},
      {label: "Pending", value: "pending"},
    ]},
    {key: "price", type: "number"},
    {key: "company", type: "text"}
  ]
  
  //// delete 
  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingInvoice, setDeletingInvoice] = useState(null)

  const { setData } = useResponse(deleteInvoice, () => {
    setShow(false)
    setDeletingInvoice(null)
    handleRefresh()
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingInvoice })
  }

  //// pay

  const [selectedInvoice, setSelectedInvoice] = useState(null)
  
  // select => send email
  const [isEmailModelOpen, setIsEmailModelOpen] = useState(false)
  const [selectedMailInvoices, setSelectedMailInvoices] = useState([])
  const handleSelectedIds = (invoice) => {
    if(selectedMailInvoices.map(inv => inv.id).includes(invoice.id)) {
      setSelectedMailInvoices(prev => prev.filter(inv => inv.id !== invoice.id))
    } else {
      setSelectedMailInvoices(prev => [...prev, invoice])
    }
  }

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.POULE_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl={"/add-invoice"}
      >
      </TableHeaderHandler>

      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({ page: 1, payload: {contractId, filters} })}
      />

      {selectedMailInvoices.length > 0 && <div className="d-flex gap-2 mb-3">
        <Badge color="dark" className="d-flex" style={{fontSize: "16px", alignItems: "center"}}>
          {selectedMailInvoices.length} selected 
          <span style={{opacity: "0.5", margin: "0px 6px"}}>|</span> 
          <i style={{cursor: "pointer"}} className="mdi mdi-close" onClick={() => setSelectedMailInvoices([])}></i>
        </Badge>

        <Button color="dark" className="me-3 fw-bold" onClick={() => setIsEmailModelOpen(true)}>
            Send Via Email
        </Button>
      </div>}

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th style={{width: "3%"}}></Th>
                <Th>Number</Th>
                {!contractId && <Th>Company</Th>}
                <Th>Date</Th>
                <Th>Paid Amount</Th>
                <Th>Price</Th>
                <Th>Status</Th>
                <Th>Pool</Th>
                <Th className="text-center" style={{ width: "15%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.invoices.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td className="text-center">
                        <input 
                          type="checkbox"
                          style={{cursor: 'pointer'}}
                          onChange={() => handleSelectedIds(row)} 
                          checked={selectedMailInvoices.map(inv => inv.id).includes(row.id)}
                          />
                      </Td>

                      <Td>{row.id}</Td>    
                      {!contractId && <Td>{row.contract.company.name}</Td>}
                      <Td>{moment(row.date).format('DD MMM YYYY')}</Td>
                      <Td >
                        {formatCurrency(row.paid_amount)}
                      </Td>
                      <Td >{formatCurrency(row.total_price)}</Td>
                      <Td >
                        <Badge style={{fontSize: "14px"}} color={STATUSE[row.status].color}>
                          {STATUSE[row.status].text}
                        </Badge>
                        {(new Date() > new Date(row.date)) && row.status != "paid" && <div className="d-block invalid-feedback">Alert: invoice date has passed</div>}
                      </Td>
                      <Td>
                        {row.contract.pool_id && <div className="d-flex align-items-center gap-1">
                          <Button size="sm" onClick={() => navigate.push('/pool-hours/'+row.contract.pool_id)} color="dark">View</Button>
                          {/* <Button size="sm" onClick={() => navigate.push('/edit-pool/'+row.contract.pool_id)} color="primary"><i className="bx bx-edit font-size-16 align-middle" /></Button> */}
                        </div>}
                      </Td>
                      <Td className="text-center">
                        <TableAction
                          hasDelete={true}
                          editPermission={PERMISSIONS.COMPANY_EDIT}
                          deletePermission={PERMISSIONS.COMPANY_DELETE}
                          type="invoice"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingInvoice}
                        />
                         <Button onClick={() => navigate.push('/invoices/'+row.id)} style={{marginLeft: "5px"}} color="dark">
                          <i className="bx bxs-show font-size-16 align-middle" />
                        </Button>

                        {row.status != "paid" && <Button onClick={() => setSelectedInvoice(row)} style={{marginLeft: "5px"}} color="dark">
                          Pay
                        </Button>}
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.invoices.length === 0} msg="No Invoices Found." />
          }
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          {selectedInvoice && <InvoicePayModal 
            show={selectedInvoice ? true : false}
            invoice={selectedInvoice}
            handleClose={() => setSelectedInvoice(null)}
            handleRefetch={handleRefresh}
          />}

          <ResultHandler error={error} loading={loading} />

          <SendInvoicesMailModal 
            isOpen={isEmailModelOpen}
            handleClose={() => setIsEmailModelOpen(false)}
            invoices={selectedMailInvoices}
            onSucess={() => setSelectedMailInvoices([])}
          />

        </div>
      </div>
    </>
  )
}
